import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyLira: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCurrencyLira"><Path d="M9.5 8.7373L15.7266 6.30176L16.2734 7.69824L9.5 10.3486V12.7373L15.7266 10.3018L16.2734 11.6982L9.5 14.3486V19.5H12C15.0376 19.5 17.5 17.0376 17.5 14H19C19 17.866 15.866 21 12 21H8V14.9355L4.77344 16.1982L4.22656 14.8018L8 13.3252V10.9355L4.77344 12.1982L4.22656 10.8018L8 9.3252V3H9.5V8.7373Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCurrencyLira;
